var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1501 11.7238L21.7198 10.4986L17.9512 2.85861C17.8483 2.64943 17.679 2.48009 17.4698 2.37716C16.9452 2.11818 16.3077 2.334 16.0454 2.85861L12.2768 10.4986L3.84655 11.7238C3.61413 11.757 3.40163 11.8666 3.23893 12.0326C3.04224 12.2348 2.93386 12.5068 2.93759 12.7888C2.94133 13.0708 3.05688 13.3398 3.25885 13.5367L9.35827 19.4834L7.91725 27.8805C7.88346 28.0758 7.90508 28.2767 7.97965 28.4604C8.05422 28.6441 8.17877 28.8032 8.33916 28.9197C8.49955 29.0361 8.68938 29.1054 8.88712 29.1195C9.08485 29.1336 9.28258 29.092 9.45788 28.9994L16.9983 25.035L24.5387 28.9994C24.7446 29.109 24.9837 29.1455 25.2128 29.1057C25.7905 29.0061 26.179 28.4582 26.0794 27.8805L24.6383 19.4834L30.7378 13.5367C30.9038 13.374 31.0133 13.1615 31.0465 12.9291C31.1362 12.3481 30.7311 11.8102 30.1501 11.7238Z",
    fill: "#FBC623"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.fb5e126ee134fb50e42d80365b8fb118.svg";
export { ForwardRef as ReactComponent };